import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import data from "./data.js";

function App() {
  return (
    <div className="container">
      <Header />
      <Menu />
      <Footer />
    </div>
  );
}

function Header() {
  const style = {
    color: "red",
    fontSize: "50px",
    textTransform: "uppercase",
  };
  return <h1 style={style}>Sruput Segar</h1>;
}

function Menu() {
  // const drinks = [];
  const drinks = data;
  const numDrinks = drinks.length;
  return (
    <main className="menu">
      <h2>Pilihan Minuman Kami:</h2>

      {numDrinks > 0 ? (
        <>
          <p>
            Aneka minuman ini disediakan oleh Sruput Segar sebagai pelepas
            dahaga yang diperlukan dalam kehidupan sehari-hari
          </p>
          <ul className="drinks">
            {data.map((drink) => (
              <Drink drinkObj={drink} key={drink.nama} />
            ))}
          </ul>
        </>
      ) : (
        <p>Maaf, stok habis</p>
      )}
    </main>
  );
}

function Footer() {
  const hour = new Date().getHours();
  const jamBuka = 10;
  const jamTutup = 18;
  const isOpen = hour >= jamBuka && hour <= jamTutup;

  if (isOpen) {
    return <FooterOpenHour jamBuka={jamBuka} jamTutup={jamTutup} />;
  } else {
    return <FooterClosedHour jamBuka={jamBuka} jamTutup={jamTutup} />;
  }
}

function FooterOpenHour({ jamBuka, jamTutup }) {
  const madeBy = {
    marginBottom: "-5em",
    fontSize: "0.8em",
    color: "gray",
  };
  return (
    <footer className="footer">
      <div className="order">
        <p>
          {new Date().getFullYear()} Sruput Segar | jam buka {jamBuka} - jam
          tutup {jamTutup}
        </p>
        <button className="btn">Order</button>
        <span style={madeBy}> Created with ♥ by Gilang Abdian</span>
      </div>
    </footer>
  );
}

function FooterClosedHour({ jamBuka, jamTutup }) {
  const madeBy = {
    marginTop: "2em",
    marginBottom: "-5.6em",
    display: "flex",
    justifyContent: "center",
    color: "gray",
    fontSize: "0.8em",
  };
  return (
    <footer className="footer">
      <p>
        Maaf, Sruput Segar masih tutup, buka jam {jamBuka} - {jamTutup}
      </p>
      <span style={madeBy}> Created with ♥ by Gilang Abdian</span>
    </footer>
  );
}

function Drink(props) {
  const { nama, deskripsi, harga, foto, stok } = props.drinkObj;
  return (
    <li className={`drink ${!stok ? "sold-out" : ""} `}>
      <img src={foto} alt={nama} width="100" height="70" />
      <div>
        <h3>{nama}</h3>
        <p>{deskripsi}</p>
        <span>{stok ? harga : "Habis"}</span>
      </div>
    </li>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
